import React from 'react';
import PropTypes from 'prop-types';

import styles from './CartProductDetailed.m.sass';

import dayjs from 'dayjs';

import ChannelImage from '../../containers/channelUtils/ChannelImage';
import Tags from '../tags/Tags';
import Pricing from '../pricing/Pricing';
import DeleteIcon from '-!svg-react-loader?name=DeleteIcon!../modals/assets/delete.svg';
import RoundButton from "../roundButton/RoundButton";
import DateHint from '../productPurchase/dateHint/DateHint';

export default function CartProductDetailed({name, image, price, quantity, eventOccurrence, options, onRemoveClick}) {
  let optionDescriptions = [];

  if (quantity > 1) {
    optionDescriptions.push(`x${quantity}`);
  }

  if (options && options.length) {
    optionDescriptions = optionDescriptions.concat(options.map(option => option.label));
  }

  return (
    <div className={styles.cartProduct}>
      <div className={styles.cartProduct_image}>
        <ChannelImage
          src={image}
          alt={name}
        />
      </div>
      <div className={styles.cartProduct_desc}>
        <div className={styles.cartProduct_name}>
          {name}

          {eventOccurrence && (
            <div className={styles.cartProduct_options}>
              {
                DateHint.getDateHint(dayjs(eventOccurrence))
                  ? DateHint.getDateHint(dayjs(eventOccurrence)).toUpperCase() + ', '
                  : false
              }
              {
                dayjs(eventOccurrence).format('DD MMM, HH:mm').toUpperCase()
                + ` (${(Intl && Intl.DateTimeFormat().resolvedOptions().timeZone && Intl.DateTimeFormat().resolvedOptions().timeZone.replace('/', ', ')) || dayjs().format('Z')})`
              }
            </div>
          )}
          {!!(optionDescriptions && optionDescriptions.length) && (
            <div className={styles.cartProduct_options}>
              <Tags tags={optionDescriptions}/>
            </div>
          )}
        </div>
        <div className={styles.cartProduct_price}>
          <Pricing
            value={price}
            small
            accent
          />
        </div>
      </div>
      <div className={styles.cartProduct_controls}>
        <RoundButton onClick={onRemoveClick}>
          <DeleteIcon/>
        </RoundButton>
      </div>
    </div>
  );
}




// WEBPACK FOOTER //
// ./components/cartProduct/CartProductDetailed.js